/**
 * ORGANIZATION_SUBSCRIPTIONS REQUESTS
 */

import { ORGANIZATION_SUBSCRIPTIONS } from '../apiUrl'
import Axios from './axiosSetup';

/**
 * Check organization uid Request
 * @returns 
 */
export const CheckOrganization = (uid: string) => {
  return Axios.post(`${ORGANIZATION_SUBSCRIPTIONS}/check`, {uid});
}

/**
 * Check organization code Request
 * @returns 
 */
export const CheckOrganizationCode = (formData: {uid: string, code: string}) => {
  return Axios.post(`${ORGANIZATION_SUBSCRIPTIONS}/check-code`, formData);
}

/**
 * Get subscription
 * @returns 
 */
export const GetSubscriptions = (uid: string) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.get(`${ORGANIZATION_SUBSCRIPTIONS}/${uid}`);
}

/**
 * Get all subscriptions
 * @returns 
 */
export const GetAllSubscriptions = () => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.get(`${ORGANIZATION_SUBSCRIPTIONS}?populate=*`);
}

